import { SxProps } from "@mui/material";

export const sxButtonText: SxProps = {
    textDecoration: 'underline',
    textTransform: 'none',
    fontFamily: 'Unimed-Sans',
    fontWeight: 600,
    padding: 0,
    '&:hover': {
      color: '#164029',
    },
    color: '#383838'
}

export const sxButtonVoltar: SxProps = {
    alignSelf: 'flex-start',
    marginTop: 'auto',
}
